import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { userId: Number }

  connect() {
    const currentUserId = Number(document.body.dataset.currentUserId)
    const bubble = this.element.querySelector(".chat-bubble")
    const wrapper = this.element.querySelector(".chat-wrapper")
    const meta = this.element.querySelector(".chat-meta")

    if (currentUserId === this.userIdValue) {
      // Sent by current user
      this.element.classList.add("justify-end")
      if (wrapper) wrapper.classList.add("items-end")
      if (bubble) bubble.classList.add("bg-indigo-600", "text-white", "rounded-br-none")
      if (meta) meta.classList.add("text-right")
    } else {
      // Sent by other user
      this.element.classList.add("justify-start")
      if (wrapper) wrapper.classList.add("items-start")
      if (bubble) bubble.classList.add("bg-slate-100", "dark:bg-slate-800", "text-slate-800", "dark:text-slate-200", "border", "border-slate-200", "dark:border-slate-700", "rounded-bl-none")
      if (meta) meta.classList.add("text-left")
    }
    // Make sure it is visible after styling
    this.element.classList.remove("opacity-0")
  }
}
